import { Component, OnInit, ElementRef, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { Experience } from 'src/app/services/experience.service';
import { NavigationEnd, ActivatedRoute, Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { Location, isPlatformBrowser } from '@angular/common';
import { SharedModule } from '../../share/shared.module';
import { CanonicalService } from '../../services/canonical.service';
import * as globalConstant from '../../global_constant';
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
	selector: 'app-location',
	//   AgmCoreModule.forRoot({
	// 	apiKey: 'AIzaSyANw4iseDOYx2YPegAduS1D1thCnz0xoAA'
	//   }),
	standalone: true,
	imports: [
		SharedModule
	],
	templateUrl: './location.component.html',
	styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

	@ViewChild('videoElement', { static: false }) videoElement: ElementRef;
	result: any = [];
	topTenCategories: any = [];
	sub_categories: any = [];
	sub_categories_arr: any = [];
	//	resultRegion 	 			= [];
	slug: string = '';
	image_url: string = '';
	image_url_category: string = '';
	view_position: string = '';
	//image_url_region:string	 	= '';
	sub_categoies_length: number = 0;
	count: number = 0;
	openedWindow: number = 0;
	lat = 39.5500507;
	lng = -105.7820674;
	map_zoom = 6;
	//selectedMarker;
	markers: any = [];
	pageUrl: any = '';
	siteUrl: String = globalConstant?.WEBSITE_URL;
	imageUrl: any = '';
	isBrowser: boolean;
	show_why_is_awesome: any = 0;
	//mapType = 'satellite';
	addMarker(id: number, lat: number, lng: number, url: string, name: string, slug: string) {
		this.markers.push({ id, lat, lng, alpha: 0.4, url, name, slug });
	}

	/*max(coordType: 'lat' | 'lng'): number {
		return Math.max(...this.markers.map(marker => marker[coordType]));
	}

	min(coordType: 'lat' | 'lng'): number {
		return Math.min(...this.markers.map(marker => marker[coordType]));
	}

	selectMarker(event) {
		this.selectedMarker = {
			lat: event.latitude,
			lng: event.longitude	
		};
	}*/
	openWindow(id, i) {
		this.openedWindow = id;
		this.markers[i]['url'] = "assets/images/vebo_map_marker_red.png";
	}
	closeWindow(id, i) {
		this.openedWindow = 0;
		this.markers[i]['url'] = "assets/images/vebo_map_marker_green.png";
	}
	isInfoWindowOpen(id) {
		return this.openedWindow == id;
	}
	onMouseOver(infoWindow, m, i) {
		infoWindow.open();
		m.url = "assets/images/vebo_map_marker_red.png";
	}
	onMouseOut(infoWindow, m, i) {
		infoWindow.close();
		m.url = "assets/images/vebo_map_marker_green.png";
	}

	constructor(private experience: Experience,
		private canonicalService: CanonicalService,
		private router: Router,
		private titleService: Title,
		private _location: Location,
		private metaService: Meta,
		private activatedRoute: ActivatedRoute,
		@Inject(PLATFORM_ID) platformId: Object
	) {

		let currenturl = this.router.url;
		let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
		const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
		this.canonicalService.setCanonical(canonicalUrl);
		this.pageUrl = canonicalUrl;

		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {
			window.scrollTo(0, 0);
		}

		this.activatedRoute.queryParams.subscribe(params => {
			if (params['view_position']) {
				this.view_position = params['view_position'];
			}
		});

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.slug = this.router?.url?.split('/')[2]?.split('?')[0];
				this.experience.getLocationPageContent(this.slug).subscribe(res => {
					if (res.response == 'success') {

						this.result = res.data;
						this.imageUrl = res.image_url;
						this.addMetaTags();
						if (this.result.latitude != "" && this.result.longitude) {
							this.lat = Number(this.result.latitude);
							this.lng = Number(this.result.longitude);
							this.map_zoom = Number(this.result.map_zoom);
						}

						if (this.result.image) {
							if (this.isBrowser) {
								if (document.getElementById('cover_image_url') != null) {
									document.getElementById('cover_image_url').setAttribute("src", "assets/images/largeloading.gif");
									setTimeout(() => {
										document.getElementById('cover_image_url').setAttribute("src", this.image_url + this.result.image);
									}, 500)
								}
							}
						}
						var i = 0;
						this.show_why_is_awesome = 0;
						if ((this.result.location_content).length > 0) {
							(this.result.location_content).forEach(item => {
								if (item.name && item.description) {
									i++;
									this.show_why_is_awesome = i;
								}
							});
						}

						// if(this.result.page_title){
						// 	this.titleService.setTitle(this.result.page_title);
						// }else{
						// 	this.titleService.setTitle(this.result.name+globalConstant.SITE_TITLE_SEPARATOR+globalConstant.SITE_TITLE);
						// }
						// this.addMetaTags();
						this.markers = [];
						if ((res.data.sub_categoies).length > 0) {
							(res.data.sub_categoies).forEach(item => {
								this.markers.push({ id: item.id, lat: item.latitude, lng: item.longitude, alpha: 1, url: "assets/images/vebo_map_marker_green.png", name: item.name, slug: item.slug, image: item.image })
							});
						}
						this.image_url = res.image_url;
						this.sub_categories = [...res.data.sub_categoies];
						this.sub_categoies_length = (res.data.sub_categoies).length;
						this.sub_categories_arr = (this.sub_categories).splice(Math.ceil(this.sub_categoies_length / 2));

						this.experience.getTopTenCategories(res.data.id).subscribe(res => {
							this.topTenCategories = res.data;
							this.image_url_category = res.image_url;
						});


						if (this.isBrowser) {
							if (this.view_position == 'top_ten_category') {
								setTimeout(function () {
									window.scrollTo(0, 1350);
								}, 100);
							}
						}
						if (this.videoElement) {
							this.videoElement.nativeElement.load(); // play video
						}
					}
				});
			}
		});
	}
	exploreOwl: OwlOptions = {
		margin: 20,
		items: 4,
		dots: false,
		nav: true,
		autoplay: false,
		loop: false,
		rewind: true,
		// goToFirst: true,
		navText: ["<span class='arrowLeft'></span>",
			"<span class='arrowRight'></span>"],
		responsive: {
			0: {
				items: 2
			},
			576: {
				items: 3
			},
			768: {
				items: 4
			},
			992: {
				items: 6
			}
		},
		// autoplayTimeout: 1520,
		smartSpeed: 500,
		// animateIn: 'linear',
		// animateOut: 'linear'
	}

	ngOnInit() {

	}

	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}


	markerClicked(marker_data) {
		this.router.navigate(['/location-region/' + this.slug + '/' + marker_data.slug]);
	}


	viewAllExperience(slug: string) {
		this.router.navigate(['/location-region/' + slug], { queryParams: { view_exp: true } });
	}

	navigateToTopTenCategory(event: Event, slug: string, position: string = '') {
		event.preventDefault();
		this._location.replaceState('/locations/' + this.slug + "?view_position=" + position);
		setTimeout(() => {
			this.router.navigate(['/top-ten-category/' + slug], { queryParams: { 'view_position': 'top_ten_category', 'location': this.slug } });
		}, 10);
	}

	addMetaTags() {
		this.metaService.updateTag({ property: 'og:image', content: `${this.imageUrl}${this.result?.image}` });
		if (this.result?.seo_title && this.result?.seo_title != null && this.result?.seo_title != '') {
			this.titleService.setTitle(this.result?.seo_title);
			this.metaService.updateTag({ property: 'og:title', content: this.result?.seo_title });

		} else {
			this.titleService.setTitle(this.result?.name);
			this.metaService.updateTag({ property: 'og:title', content: this.result?.name });

		}
		this.metaService.updateTag({ property: 'og:url', content: this.pageUrl });
		if (this.result.seo_description != null && this.result.seo_description != '') {
			this.metaService.updateTag({ property: 'og:description', content: this.result.seo_description });
			this.metaService.updateTag({ property: 'description', content: this.result.seo_description });
		} else {
			this.metaService.updateTag({ property: 'og:description', content: this.result.name });
			this.metaService.updateTag({ property: 'description', content: this.result.name });
		}
	}
}
